import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { HeaderCalendar } from './calendar/header-calendar/module';

// Maintenance Components
import { ActivitiesComponent } from './activities/activities.component';
import { ActivitieDetailComponent } from './activities/activitie-detail/activitie-detail.component';
import { CalendarComponent } from './calendar/calendar/calendar.component';
import { ModalCalendarComponent } from './calendar/modal-calendar/modal-calendar.component';
import { ScheduledComponent } from './calendar/scheduled/scheduled.component';
import { EquipmentComponent } from './equipment/equipment.component';
import { EquipmentDetailComponent } from './equipment/equipment-detail/equipment-detail.component';
import { ModalEquipmentComponent } from './equipment/modal-equipment/modal-equipment.component';
import { CveEquipoComponent } from './equipment/cve-equipo/cve-equipo.component';
import { MaintenanceHistoryComponent } from './maintenance-history/maintenance-history.component';
import { ModalHistoryComponent } from './maintenance-history/modal-maintenance-history/modal-maintenance-history.component';
import { WorkOrderSummaryComponent } from './maintenance-history/work-order-summary/work-order-summary.component';
import { MaintenanceOrdersComponent } from './maintenance-orders/maintenance-orders/maintenance-orders.component';
import { ModalMaintenanceOrdersComponent } from './maintenance-orders/maintenance-orders/modal-maintenace-orders/modal-maintenace-orders.component';
import { MaintenanceOrdersExecutionComponent } from './maintenance-orders/maintenance-orders-execution/maintenance-orders-execution.component';
import { MaintenaceOrderDetailComponent } from './maintenance-orders/maintenance-orders/maintenace-order-detail/maintenace-order-detail.component';
import { MaintenanceOrdersDispatchComponent } from './maintenance-orders/maintenance-orders-dispatch/maintenance-orders-dispatch.component';
import { MaintenanceRequestComponent } from './maintenance-request/maintenance-request.component';
import { MaintenanceRegisterComponent } from './maintenance-register/maintenance-register.component';

const MaintenanceComponents = [
  ActivitiesComponent,
  ActivitieDetailComponent,
  CalendarComponent,
  ModalCalendarComponent,
  ScheduledComponent,
  EquipmentComponent,
  EquipmentDetailComponent,
  ModalEquipmentComponent,
  CveEquipoComponent,
  MaintenanceHistoryComponent,
  ModalHistoryComponent,
  WorkOrderSummaryComponent,
  MaintenanceOrdersComponent,
  ModalMaintenanceOrdersComponent,
  MaintenanceOrdersExecutionComponent,
  MaintenaceOrderDetailComponent,
  MaintenanceOrdersDispatchComponent,
  MaintenanceRequestComponent,
  MaintenanceRegisterComponent
];

@NgModule({
  declarations: MaintenanceComponents,
  imports: [
    SharedModule,
    HeaderCalendar,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    })
  ],
  exports: MaintenanceComponents
})
export class MaintenanceModule { }
